"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextLoop = require("./components/TextLoop");

var _TextLoop2 = _interopRequireDefault(_TextLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextLoop2.default;